document.addEventListener("DOMContentLoaded", () => {
    const chevronSvg = `<svg height="64px" width="64px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 185.343 185.343" xml:space="preserve" fill="#000000" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#010002;" d="M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175 l74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934 c4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z"></path> </g> </g> </g></svg>`
    const binSvg =  `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 6H21M5 6V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V6M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 11V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M10 11V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`
   
    let currentStage = 1; 
    let globPackSize;
    let globPantsSize;
    let globProds;
    let globSelectedProds= [];
    let globOrderedProds;
    let globBundlePrice;
    let globBundleComp;

    const toggle = document.getElementById("bundle-toggle");

    document.querySelectorAll(".pdp-bab-s1-bundle-options label").forEach((label) => {
        label.addEventListener("click", () => {
            toggle.checked = false;
        });
    });

    const shuffleBundle  = () => {

        const prevSorted = document.querySelectorAll(".shuffle-sorted")
        Array.from(prevSorted).forEach((item)=>{
            item.classList.remove("shuffle-sorted")
        })
        const selectedSizes = document.querySelectorAll(".pdp-bab-skus-wrapper label:has(input:checked)");
        let sizes = []
        Array.from(selectedSizes).forEach((size)=>{
            const sizeName = size.dataset.name;
            const countEle = size.closest(".pdp-bab-product-wrapper").querySelector(".pdp-bab-count")
            for(let i = 0; i< countEle.value; i++){

                sizes.push(sizeName);
            }
            const input = size.querySelector("input");
            countEle.value = 1;
            input.checked = false;
        })
        const prodCards = Array.from(document.querySelectorAll(".pdp-bab-product-wrapper"))
        const usedProductIds = new Set();

        sizes.forEach(size => {

            const patternedSelected = document.querySelector("#pdp-bundle-style-choice-patterned input:checked");
            const plainSelected = document.querySelector("#pdp-bundle-style-choice-plain input:checked");

            const candidates = globOrderedProds
            .filter(prod => {
                if (usedProductIds.has(prod.productId)) return false;
                if (patternedSelected && !(prod.tags?.includes("style-patterned") || prod.tags?.includes("style-adventurous"))) {
                return false;
                }

                if (plainSelected && !(prod.tags?.includes("style-plain")||prod.tags?.includes("style-classic"))) {
                return false;
                }
                const hasValidSku = prod.skus.some(sku =>
                sku.name.toLowerCase() === size.toLowerCase() &&
                sku.inventoryLevel > 0
                );

                return hasValidSku;
            });

            if (!candidates.length) return;

            const randomIndex = Math.floor(Math.pow(Math.random(), 2) * candidates.length);
            const prod = candidates[randomIndex];

            usedProductIds.add(prod.productId);

            const matchingCard = prodCards.find(card =>
                card.dataset.id == prod.productId
            );

            if (!matchingCard) return;

            const matchingSize = Array.from(
                matchingCard.querySelectorAll(".pdp-bab-skus-wrapper label")
            ).find(ele =>
                ele.dataset.name.toLowerCase() === size.toLowerCase()
            );

            if (!matchingSize) return;

            matchingCard.querySelector(".current-size-name").innerHTML = size;
            matchingCard.classList.add("shuffle-sorted");
            if(matchingSize.querySelector("input").checked == true){
                mathcingCard.querySelector(".pdp-bab-count").value = Number(mathcingCard.querySelector(".pdp-bab-count").value) + 1
            }else{
                matchingSize.querySelector("input").checked = true;
            }

        });
        bundleChange()
    }

    const completeBundle = () => {
        const selectedProds = globSelectedProds || [];
        const alreadyCount = selectedProds.reduce((prev, next) => prev + (next.count || 0), 0);

        const prodCards = Array.from(document.querySelectorAll(".pdp-bab-product-wrapper"));

        const remaining = Math.max(0, (globPackSize || 0) - alreadyCount);
        if (!remaining) {
            bundleChange();
            return;
        }

        const usedProductIds = new Set(selectedProds.map(p => String(p.productId)));

        const getCardByProdId = (id) => prodCards.find(card => String(card.dataset.id) === String(id));

        const sizeKey = String(globPantsSize || "").toLowerCase();

        const candidates = (globOrderedProds || []).filter(prod => {
            if (!prod) return false;
            if (usedProductIds.has(String(prod.productId))) return false;

            const matchingSku = (prod.skus || []).find(sku =>
            String(sku.name || "").toLowerCase() === sizeKey
            );

            if (!matchingSku || !(matchingSku.inventoryLevel > 0)) return false;

            const card = getCardByProdId(prod.productId);
            if (!card) return false;

            if (card.querySelector(".pdp-bab-skus-wrapper input:checked")) return false;

            const matchingLabel = Array.from(card.querySelectorAll(".pdp-bab-skus-wrapper label"))
            .find(ele => String(ele.dataset.name || "").toLowerCase() === sizeKey);

            if (!matchingLabel) return false;

            const input = matchingLabel.querySelector("input");
            if (!input) return false;

            if(document.querySelector("#pdp-bundle-style-choice-patterned input:checked")){
                if(card.dataset.style != "patterned"){
                    return false
                }
            }
            if(document.querySelector("#pdp-bundle-style-choice-plain input:checked")){
                if(card.dataset.style != "plain"){
                    return false
                }
            }

            return true;
        });

        let filled = 0;
        for (let idx = 0; idx < candidates.length && filled < remaining; idx++) {
            const prod = candidates[idx];
            const card = getCardByProdId(prod.productId);

            const matchingLabel = Array.from(card.querySelectorAll(".pdp-bab-skus-wrapper label"))
            .find(ele => String(ele.dataset.name || "").toLowerCase() === sizeKey);

            const input = matchingLabel.querySelector("input");

            card.classList.add("shuffle-sorted");
            input.checked = true;

            usedProductIds.add(String(prod.productId));
            filled += 1;
        }

        bundleChange();
    };

    const bundleChange = () => {
        const selectedProdCards = Array.from(document.querySelectorAll(".pdp-bab-product-wrapper:has(.pdp-bab-skus-wrapper input:checked)"))
        
        let totalCount = 0;
        let selectedProds = []
        selectedProdCards.forEach((card)=>{
            const countEle = card.querySelector(".pdp-bab-counter")
            const count = Number(card.querySelector(".pdp-bab-count").value);
            
            const size = card.querySelector(".pdp-bab-skus-wrapper label:has(input:checked)").dataset.name;
            const availableCount = card.querySelector(".pdp-bab-skus-wrapper label:has(input:checked)").dataset.count; 
            if(availableCount == count){
                card.querySelector(".pdp-bab-plus").classList.add("all-stock-selected")
            }else{
                card.querySelector(".pdp-bab-plus").classList.remove("all-stock-selected")
            }
            countEle.innerHTML =  count+ "-" + size 
            const productId = card.dataset.id
            const product = globProds.find((prod)=>{
                return prod.productId == productId
            })
            const prodObj = {
                count,
                size,
                product
            }
            selectedProds.push(prodObj)
        })
        globSelectedProds = selectedProds;
        const count = selectedProds.reduce((prev,next)=>{
            return prev + next.count
        },0)
        
        const stage2Wrapper = document.getElementById("pdp-bab-stage-2-wrapper");
        if(count == globPackSize){
            stage2Wrapper.classList.add("products-full")
            stage2Wrapper.classList.remove("products-missing")
        }else{
            stage2Wrapper.classList.add("products-missing")
            stage2Wrapper.classList.remove("products-full")
        }
        const countEles = document.querySelectorAll(".pdp-bab-total-selected");
        Array.from(countEles).forEach((ele)=>{
            ele.innerHTML = count;
        })
        let progress = (count/globPackSize)*100 + "%";
        const progressBar = document.getElementById("pdp-bab-progress-bar");
        progressBar.style.width = progress;


        const prodSummaryWrapper = document.getElementById("footer-product-summary");
        prodSummaryWrapper.innerHTML = "";
        selectedProds.forEach((prod)=>{
            for(let i = 0; i < prod.count; i++){
                let wrapper = document.createElement("div");
                const imgPadding = document.createElement("div");
                imgPadding.className = "pdp-bab-selected-image-padding"
                let imgEle = document.createElement("img");
                imgEle.src = prod.product.image.replace(".png", "_50x.png").replace(".jpg", "_50x.jpg");
                wrapper.append(imgEle, imgPadding)
                const name = prod.product.name.split("-")[0];
                const nameEle = document.createElement("div");
                const sizeEle = document.createElement("div");
                sizeEle.className  = "footer-product-summary-size";
                sizeEle.innerHTML = prod.size;
                nameEle.innerHTML = name;
                nameEle.className = "footer-selected"
                wrapper.append(nameEle);
                wrapper.append(sizeEle)
                wrapper.className = "footer-selected-prod-wrapper";
                prodSummaryWrapper.append(wrapper)
            }

        })
    }





    function waitForNostoJs(callback) {
        const checkInterval = setInterval(function() {
            if (typeof window.Nosto !== 'undefined') {
                clearInterval(checkInterval);
                callback();
            }
        }, 100); // Check every 100 milliseconds    
    }


    const createBundleCards = (products) => {
        const target = document.getElementById("pdp-bundle-products-loc");
        target.innerHTML = "";
        products.forEach((product)=>{
            const wrapper = document.createElement("div");
            wrapper.className = "pdp-bab-product-wrapper"
            wrapper.dataset.id = product.productId; 
            wrapper.dataset.style=  product.tags.includes("style-classic")? "plain" : product.tags.includes("style-adventurous")? "patterned" : "idk-lol"
            const imgWrapepr = document.createElement("div");
            imgWrapepr.className = "pdp-bab-image-wrapper"
            const imgPadding = document.createElement("div");
            imgPadding.className="img-padding";
            const img = document.createElement("img");
            img.src = product?.image?.replace(".png", "_300x.png").replace(".jpg", "_300x.jpg");
            imgWrapepr.append(imgPadding, img)
            imgWrapepr.className = "pdp-bab-img-wrapper"
            const countEle = document.createElement("div");
            countEle.className = "pdp-bab-counter"
            wrapper.append(imgWrapepr);
            wrapper.append(countEle);
            const titleEle = document.createElement("div");
            titleEle.innerHTML = product.name.split("-")[0]
            titleEle.className="pdp-bab-prod-title"
            wrapper.append(titleEle)
            const sizeContainer = document.createElement("div");
            sizeContainer.className = "pdp-bab-sizes-container"
            const currentSizeContainer = document.createElement("label")
            const currentSizeNameEle = document.createElement("div");
            currentSizeNameEle.innerHTML = globPantsSize;
            currentSizeNameEle.className = "current-size-name"
            const sizeIndicator = document.createElement("div");
            sizeIndicator.className = "pdp-bab-size-indicator";
            sizeIndicator.innerHTML = chevronSvg;
            currentSizeContainer.className ="pdp-bab-current-size-container"


            const sizeChoiceInput = document.createElement("input")
            sizeChoiceInput.type="checkbox";
            sizeChoiceInput.style.display = "none";
            currentSizeContainer.append(currentSizeNameEle, sizeChoiceInput, sizeIndicator);
            sizeContainer.append(currentSizeContainer);
            const skusWrapper = document.createElement("div");
            skusWrapper.className = "pdp-bab-skus-wrapper"
            const addButton = document.createElement("div");
            addButton.innerHTML = "add"
            addButton.className = "pdp-bab-add-button"
            const counter = document.createElement("div");
            counter.className = "pdp-bab-counter-wrapper"
            const minusButton = document.createElement("div");
            const currentCount = document.createElement("input")
            currentCount.type = "number"
            currentCount.value = 1;
            currentCount.className = "pdp-bab-count"
            minusButton.innerHTML = binSvg;
            minusButton.className = "pdp-bab-minus";
            const plusButton = document.createElement("div");
            plusButton.innerHTML = "+";
            plusButton.className = "pdp-bab-plus"
            counter.append(minusButton, currentCount, plusButton);
            const skuEles = product.skus.map((sku) => {
                const skuWrapper = document.createElement("label");
                skuWrapper.dataset.name = sku.name;
                skuWrapper.innerHTML = sku.name;
                skuWrapper.dataset.count = sku.inventoryLevel
                if(sku.inventoryLevel == 0){
                    skuWrapper.classList.add("sku-unavailable");
                }
                const skuInput = document.createElement("input");
                skuInput.type = "radio";
                skuInput.name = "sku" + product.productId;
                skuInput.hidden = true;
                skuWrapper.addEventListener("click", ()=>{
                    currentCount.value = Math.min(currentCount.value, sku.inventoryLevel);
                    currentSizeNameEle.innerHTML = sku.name
                    sizeChoiceInput.checked = false;
                    bundleChange();
                })
                
                skuWrapper.append(skuInput);
                
                return skuWrapper;
            });
            
            skuEles.forEach(ele => skusWrapper.append(ele));
            
            wrapper.addEventListener("click", (e) => {
                if(wrapper.querySelector(".pdp-bab-skus-wrapper input:checked")) return;

               

                if(e.target.closest(".pdp-bab-minus")) return
                const currentSkuEle = skuEles.find((ele) => {
                    return ele.dataset.name.toLowerCase() === globPantsSize.toLowerCase();
                });
                if (currentSkuEle) {
                    currentSkuEle.querySelector("input").checked = true;
                }
                bundleChange()
            });
            minusButton.addEventListener("click", ()=>{
                if(currentCount.value == 2){
                    minusButton.innerHTML = binSvg;
                }
                const currentSkuEle = skuEles.find((ele) => {
                    return ele.querySelector("input:checked");
                });
                if(currentCount.value == 1){
                    
                    if (currentSkuEle) {
                        wrapper.classList.remove("shuffle-sorted")
                        currentSkuEle.querySelector("input").checked = false;
                    }
                }else{
                    currentCount.value = Number(currentCount.value) - 1
                }
                bundleChange()
            })
            plusButton.addEventListener("click", ()=>{
                minusButton.innerHTML = "-";
                currentCount.value = Number(currentCount.value) + 1;
                const currentSkuEle = skuEles.find((ele) => {
                    return ele.querySelector("input:checked");
                });

                bundleChange();
            })
            sizeContainer.append(skusWrapper);
            wrapper.append(addButton, counter, sizeContainer)
            target.append(wrapper)

        })
    }
    const getBundleReccomendations = (collId = "291215114301", size) => {

      let filters =  size && [
    {
        "field": "tags1",
        "value": [
            `size-${size}`
        ]
    },
    
    {
        "field": "listPrice",
        "range": {
            "lte": "12.01"
        }
    }
  
]
        nostojs(api => {
            api.search({
                products: {
                    fields: ["productId", "name"],
                    size: 100,
                    categoryId: collId,
                    filter: filters

                }
            }).then(async data => {

                const timeframe = "day";
                const productIds = data.products.hits.map(p => p.productId);

                const promises = productIds.map(id => {
                    const query = `
      {
        products(limit: 1, filter: {search: "${id}"}) {
          products {
            name
            price
            productId
            skus{
                    id
                    name
                    inventoryLevel
            }
            tags1
            imageUrl
            scores {
              ${timeframe} {
                views
                buys
              }
            }
          }
        }
      }`;

                    return fetch("https://api.nosto.com/v1/graphql", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/graphql",
                            Authorization: 'Basic ' + btoa(':' + 'R7SHa2Vg91alPSCdNuHi2NAVkbVAlhkNcXezuAPzB9xX5L41juobpJxIAem5eBHF'),
                        },
                        body: query
                    }).then(res => res.json());
                });

                const results = await Promise.all(promises);
                const salesData = results.map(r => {
                    const product = r.data.products.products[0];

                    return {
                        productId: product.productId,
                        name: product.name,
                        image: product.imageUrl,
                        available: product.available,
                        skus: product.skus,
                        tags: product.tags1,
                        buys: product.scores.day?.buys || 0,
                        views: product.scores.day?.views || 0,
                        price: product.price || 12
                    };
                }).filter((prod)=>{
                    return !prod.name.includes("foundation");
                });

                globProds = salesData;
                createBundleCards(salesData)
                bundleChange();
                let orderedSales = salesData.sort((a, b) => {
                    return b.buys - a.buys;
                });
                globOrderedProds = orderedSales;


            }).catch(error => {
                console.error("Error fetching sales data:", error);
            });
        });

    }


    const changeStep = (step) =>{
        if(step == currentStage) return;
        const direction = step > currentStage;
        const allSteps = document.querySelectorAll(".pdp-bab-step-wrapper")
        const prevStepEle =  Array.from(allSteps).find((step)=>{
            return step.dataset.step ==  currentStage;
        })
        currentStage = step;
        if(prevStepEle){
            prevStepEle.classList.add("pdp-bab-page-moving-out")
        }
        const currentStepEle =  Array.from(allSteps).find((newstep)=>{
            return newstep.dataset.step ==  step;
        })
        if(currentStepEle){
            currentStepEle.classList.remove("not-current-page")
            currentStepEle.classList.add("pdp-bab-page-moving-in")
            requestAnimationFrame(()=>{
                currentStepEle.classList.remove("pdp-bab-page-moving-in");
            })
        }
        setTimeout(()=>{
            currentStepEle.classList.remove("pdp-bab-page-moving-out");
            prevStepEle.classList.add("not-current-page")
        })
    }

    const finishStepOne = () => {
        changeStep(2);
        const pantsSize = document.querySelector("#pdp-bab-s1-sizes input:checked")?.value.toLowerCase();
        const packSize = document.querySelector(".step-1-pack-size-input:checked")?.value
        const bundlePrice = document.querySelector(".step-1-pack-size-input:checked")?.dataset.bundlePrice
        const bundleComp = document.querySelector(".step-1-pack-size-input:checked")?.dataset.bundleComp
        globBundleComp = Number(bundleComp);
        globBundlePrice = Number(bundlePrice);
        globPantsSize = pantsSize;
        globPackSize = packSize;
        const sizeEles = document.querySelectorAll(".pdp-bab-bundle-size");
        Array.from(sizeEles).forEach((ele)=>{
            ele.innerHTML = packSize;
        })
        getBundleReccomendations("291215114301", pantsSize)
    }

    const finishStepTwo = () => {
        changeStep(3)
        const prodLoc = document.getElementById("pdp-bab-stage-3-products-loc");
        prodLoc.innerHTML = "";
        let bundlePrice = 0;
        globSelectedProds.forEach((product)=>{
            bundlePrice += (Number(product.product.price) * product.count);
            const wrapper = document.createElement("div");
            wrapper.className = "pdp-bab-final-stage-product shadow-sm";
            const img = document.createElement("img");
            img.src = product.product.image.replace(".png","_50x.png").replace("jpg", "_50x.jpg");
            wrapper.append(img);
            const prodInfo = document.createElement("div");
            prodInfo.className = "pdp-bab-final-stage-info-wrapper";
            const title = product.product.name;
            const titleEle = document.createElement("div");
            titleEle.innerHTML = title;
            titleEle.className = "pdp-bab-final-stage-prod-title";
            const sizeEle = document.createElement("div");
            sizeEle.innerHTML ="Size: " + product.size;
            const seperator = document.createElement("div");
            seperator.className = "pdp-bab-final-stage-separator";
            const sizeQuantityEle = document.createElement("div");
            sizeQuantityEle.className = "pdp-bab-final-stage-size-quantity-ele";
            const quantityEle = document.createElement("div");
            quantityEle.innerHTML = "Quantity: " + product.count;
            sizeQuantityEle.append(sizeEle,seperator,  quantityEle);
            prodInfo.append(titleEle, sizeQuantityEle);
            wrapper.append(prodInfo)
            prodLoc.append(wrapper);

        })
        document.getElementById("pdp-bab-subtotal-price").innerHTML = "£" + globBundleComp;
        document.getElementById("pdp-bab-total-price").innerHTML = "£" + Math.min(globBundlePrice, bundlePrice).toFixed(2);
        const discount = globBundleComp - Math.min(globBundlePrice, bundlePrice);
        document.getElementById("pdp-bab-price-price").innerHTML = "£" + discount.toFixed(2);

        if(bundlePrice < globBundlePrice){
            document.getElementById("overpriced-bundle").style.display = "block"
        }else{
            document.getElementById("overpriced-bundle").style.display = "none"

        }
    }
    const openBab = () => {
        document.getElementById("pdp-bab-popup-wrapper").style.display = "block";
        document.body.style.overflow = "hidden"
        const preselectedSizeEle = document.querySelector("[data-option-name='Size'] .product-variant:has(input:checked)");
        if(preselectedSizeEle){
            const preselectedSize = preselectedSizeEle.dataset.optionValue;
            const babInputs = document.querySelectorAll("#pdp-bab-s1-sizes input");
            Array.from(babInputs).forEach((input)=>{
                if(input.value.toLowerCase() == preselectedSize.toLowerCase()){
                    input.checked = true;
                }
            })
        }
        const productJSON = JSON.parse(document.querySelector("#product-json")?.value);
        const tags = productJSON.tags;
        const bundleSizeTag = tags.find((tag)=>{
            return tag.includes("bundle-selector-")
        })
        if(bundleSizeTag){
            const bundleSize = bundleSizeTag.replace("bundle-selector-","")[0];
            const bundleInputs = Array.from(document.querySelectorAll(".bundle-option input"));
            bundleInputs.forEach((input)=>{
                if(input.value == bundleSize){
                    input.checked = true;
                }
            })
        }
    }
    const closeBab = () => {
        document.getElementById("pdp-bab-popup-wrapper").style.display = "none"
        document.body.style.overflow = "auto"
    }

    document.addEventListener("click", (e) => { 
        

        if(e.target.closest(".pdp-bab-close")){
            closeBab();
            changeStep(1);
            document.getElementById("pdp-bundle-products-loc").innerHTML = "";
            bundleChange();
        }
        if(e.target.closest("#pdp-bab-popup-button")){
            openBab()
        }
        if(e.target.closest("#pdp-bab-s2-back")){

            changeStep(1);
            document.getElementById("pdp-bundle-products-loc").innerHTML = "";
            bundleChange();
        }
        if(e.target.closest(".stage-3-back")){
            changeStep(2);
        }
        if (e.target.closest(".pdp-complete-bab")) {
            getBundleReccomendations()
        }
        if(e.target.closest("#pdp-bab-end-step-1")){
            finishStepOne();
        }
         if(e.target.closest("#pdp-bab-magic-button")){
             completeBundle();
            }
        if(e.target.closest("#shuffle-bundle-button")){
            shuffleBundle();
        }
        if(e.target.closest("#stage-2-button-ready")){
            finishStepTwo();
        }
    })
        document.addEventListener("click", async (e) => {
        if(e.target.closest("#add-pdp-bab-to-cart-button")){
    e.target.closest("#add-pdp-bab-to-cart-button").classList.add("loading")
    let timeStamp = Date.now();
    
    const items = globSelectedProds.map(prod => {
        const matchingSku = prod.product.skus.find(sku => sku.name === prod.size);
        if (!matchingSku) return null;
        let imageUrl = `https://cdn.shopify.com/s/files/1/0353/7249/files/${globPackSize}_pack.png?v=1778845721`
        return {
            id: matchingSku.id,
            quantity: prod.count,
            properties: {
                "_bundleId": timeStamp,
                "_bundleVariantId": "42987642290237",
                "_bundleTitle": "Mens Boxers " + globPackSize + " Pack",
                "_bundleImage": imageUrl,
                "_bundleType": "build a bundle"
            }
        };
    }).filter(Boolean);

    // Chunk into groups of 8
    const chunkSize = 4;
    for (let i = 0; i < items.length; i += chunkSize) {
        const chunk = items.slice(i, i + chunkSize);
        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: chunk })
        });
    }

    e.target.closest("#add-pdp-bab-to-cart-button").classList.remove("loading")
    updateCart();
}
    })

    addPdpBabToCart = async (options = {}) => {
        const normalizedOptions = {
            varId: options.varId,
            quantity: options.quantity,
            properties: options.properties || {},
            productId: options.productId || "",
            productTitle: options.productTitle || ""
        };

        if (!normalizedOptions.varId || !normalizedOptions.quantity) {
            throw new Error("varId and quantity are required");
        }

        const form = createForm(normalizedOptions);
        const formLoc = document.getElementById("atc-form-loc");

        if (!formLoc) {
            throw new Error("no atc form location");
        }

        formLoc.append(form);

        const formData = new FormData(form);
        const dataString = new URLSearchParams(formData).toString();

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json",
            },
            body: dataString,
        });

        if (!response.ok) {
            const json = await response.json();
            throw new Error(json.description || "Failed to add to cart");
        }

        const cartItem = await response.json();

        document.dispatchEvent(
            new CustomEvent("itemAddedToCart", {
            detail: {
                variant: normalizedOptions.varId,
                cartItem,
                formData,
            },
            })
        );

        return cartItem;
    };

    const createForm = ({
    varId,
    quantity,
    properties,
    productId,
    productTitle,
    productPrice
    }) => {
        const newFormProps = Object.fromEntries(
            Object.entries(properties).map(([key, value]) => [
                `properties[${key}]`,
                value
            ])
        );


        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        form.id = `product-form-${productId}`;
        form.acceptCharset = 'UTF-8';
        form.className = "product-form hidden";
        form.enctype = 'multipart/form-data';
        form.setAttribute('data-product-id', productId);
        form.setAttribute('novalidate', 'novalidate');
        form.setAttribute('data-type', 'add-to-cart-form');
        const formProps = {
            ...newFormProps,
            "form_type": "product",
            "utf8": "✓",
            "id":varId,
            "quantity": quantity,
            "product-id": productId,
        }
        Object.entries(formProps).forEach(([name, value]) => {
            if (value === undefined || value === null) return;

            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = String(value);
            form.appendChild(input);
        });
        const atcButton = document.createElement('button');
        atcButton.type = 'submit';
        atcButton.classList.add('add-to-cart-button', 'hidden');
        form.appendChild(atcButton);
        form.addEventListener('submit', function(event) {
            event.preventDefault();
        });
        return form;

    };


})